<template>
  <div>
    <b-modal v-model="modalShow" centered ok-only class="text-center text-info">
      Please Select Category and City
    </b-modal>
    <div
      v-if="deferredPrompt"
      class="alert alert-info alert-dismissible fade show"
      role="alert"
      style="
        margin-bottom: 0px;
        background-color: #fa9b47;
        border: none;
        border-radius: 0px;
        color: #fff;
      "
    >
      Get the App. It's less than 1 MB
      <a
        style="cursor: pointer; color: #031c35"
        @click="promptInstall()"
        class="alert-link"
        >INSTALL NOW</a
      >
      <button
        type="button"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
      >
        <span aria-hidden="true" style="color: #fff">&times;</span>
      </button>
    </div>
    

    <div class="infobox">
      
       <div class="">
      <section>
        <div style="background-color: #3232322e; height: 100%" class="">
            <nav
              class="navbar navbar-expand-lg navbar-dark bg-dark m-nav"
              style="z-index: 10"
            >
              <router-link class="navbar-brand" to="/">
                <img
                  src='../../static/img/logo/Logo2.jpeg' width="50" height="50"
                  alt="eshops-logo"
                />
              </router-link>
              <button
                class="navbar-toggler float-right"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                  <li class="nav-item mt-2">
                    <router-link
                      :to="{ name: 'home' }"
                      class="m-link nav-link text-white"
                      >Home</router-link
                    >
                  </li>
                  <!-- <li class="nav-item">
                    <router-link
                      :to="{ name: 'regshop', params: { plan: 'Premium' } }"
                      class="m-link nav-link text-white"
                      >Create Store</router-link
                    >
                  </li> -->
                  <li class="nav-item">
                    <router-link
                      v-if="admin"
                      :to="{ name: 'admin' }"
                      class="m-link nav-link text-white"
                      >Admin</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link
                      v-if="pageadmin"
                      :to="{ name: 'admin-services' }"
                      class="m-link nav-link text-white"
                      >Admin</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link
                      v-if="visitor"
                      :to="{ name: 'signin' }"
                      class="m-link nav-link text-white"
                      >Sign in</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link
                      v-if="visitor"
                      :to="{ name: 'usersignup' }"
                      class="m-link nav-link text-white"
                      >Sign up</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <router-link
                      v-if="user"
                      :to="{ name: 'myaccount' }"
                      class="m-link nav-link text-white"
                      >My Account</router-link
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      style="cursor: pointer"
                      @click="logout()"
                      v-if="user || admin || pageadmin || editor"
                      class="m-link nav-link text-white"
                      >Sign out</a
                    >
                  </li>
                </ul>
              </div>
            </nav>

            <!-- Just an image -->
            <nav
              class="navbar navbar-dark bg-dark d-nav"
              style="background-color: #444444b8 !important"
            >
              <router-link class="navbar-brand" to="/">
                <img
                  src='../../static/img/logo/Logo2.jpeg' width="50" height="50"
                  alt="eshops-logo"
                />
              </router-link>
              <div>
                <router-link :to="{ name: 'home' }" class="text-white mr-5">
                  Home
                </router-link>
                <!-- <router-link
                  :to="{ name: 'regshop', params: { plan: 'Premium' } }"
                  class="text-white mr-5"
                >
                  Create Store</router-link
                > -->
                <router-link
                  v-if="admin"
                  :to="{ name: 'admin' }"
                  class="m-link text-white mr-5"
                  >Admin</router-link
                >
                <router-link
                  v-if="pageadmin"
                  :to="{ name: 'admin-services' }"
                  class="m-link text-white mr-5"
                  >Admin</router-link
                >
                <router-link
                  v-if="visitor"
                  :to="{ name: 'signin' }"
                  class="m-link text-white mr-5"
                  >Sign in</router-link
                >
                <router-link
                  v-if="visitor"
                  :to="{ name: 'usersignup' }"
                  class="m-link text-white mr-5"
                  >Sign up</router-link
                >
                <router-link
                  v-if="user"
                  :to="{ name: 'myaccount' }"
                  class="m-link text-white mr-5"
                  >My Account</router-link
                >
                <a
                  style="cursor: pointer"
                  @click="logout()"
                  v-if="user || admin || pageadmin || editor"
                  class="text-white mr-5"
                  >Sign out</a
                >
              </div>
            </nav>

            <!-- <header class="" id="home">
        <div class="container ">
            <h1>It’s All About Success of Your Business.</h1>
            <p class="tagline">The straightforward and timely way to grow your business in the modern world is an online business.</p>
        </div>
        <div class="img-holder"><img src="../../static/img/iphonex.png" alt="phone" class="img-fluid animated infinite pulse delay-3s slower"></div>
    </header> -->

          
          </div>
      </section>
    </div>
      <section id="benefits">
        <div class="container section-why" id="section-why" style="">
        <section
          id="icon-boxes"
          class="py-5 mt-5"
          style="background-color: #f8f8f8; border-radius: 5px"
        >
          <div class="container">
            <div class="row mb-1">
              <div class="col-md-6 d-flex mx-auto align-items-center">
                <div>
                  <h2
                    class="display-5 pb-2 pl-3 text-center mquery-h"
                    style="color: #787878"
                  >
                    SPECIAL BENEFITS FOR RESTAURANTS & CAFES
                  </h2>
                  <!-- <p class="mb-2 h5 pb-2 txt-g mquery-p text-center" style="">
                    Customers are the biggest asset of any business. Make them
                    feel proud about your business, give them a better and
                    comfortable shopping experience with eshops.lk
                  </p> -->
                </div>
              </div>
            </div>
            <div class="row ">
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <h3 class="mb-1">Online Orders & Takeaway Orders
& KOT/BOT
</h3>
                    <p class="text-left">
                      Online ordering can streamline your systems in
the kitchen. When customers send their orders
online, it decreases the amount of time staff
members need to spend on the phone. Instead,
the team can complete the steps — such as
cooking & packaging. It ensures that every meal
is ready for your customers on time.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <!-- <i class="fa fa-clock-o fa-3x mb-2" aria-hidden="true"></i> -->
                    <h3 class="mb-1">Easily Manage Complete Menu</h3>

                    <p class="text-left">
                      Restaurants can update and display their menu
items, prices, and promotions quickly and
easily. 86% of customers are ready to buy after
seeing menu online. 90% of customers search for food delivery
and takeout online.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <!-- <i
                      class="fa fa-fighter-jet fa-3x mb-2"
                      aria-hidden="true"
                    ></i> -->
                    <h3 class="mb-1">Make It Easier for Your Customers to Order</h3>
                    <p class="text-left">
                      Customers can view menu items & promotions
from mobile phones & place orders at any time
from anywhere, and track their order status.
Customers don't like to sit in their car or the
restaurant to wait for their food. Reduce
customer waiting time and increase customer
satisfaction.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <h3 class="mb-1">No commission for online orders</h3>
                    <p class="text-left">
                      Many restaurants have jumped on the online
ordering trend by partnering with delivery services
like PickMe, and UberEats. These companies charge
higher commissions either from you or your
customers.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <!-- <i class="fa fa-clock-o fa-3x mb-2" aria-hidden="true"></i> -->
                    <h3 class="mb-1">Increas the Reach</h3>

                    <p class="text-left">
                    It also increases word-of-mouth marketing.
Promotions and discounts can bring customers
through the door, When customers eat something
they love, they post it online and tell about their
meal to friends and family. This is the key to success
today.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="bg-light text-center text-secondary">
                  <div class="card-block py-4">
                    <!-- <i
                      class="fa fa-fighter-jet fa-3x mb-2"
                      aria-hidden="true"
                    ></i> -->
                    <h3 class="mb-1">Better customers data</h3>
                    <p class="text-left">
                      Who are your regular customers? What do they
like ordering? Which food items are popular?
Are they aware of the promotions and offers on
the website? These questions can be answered
using analytics and insights provided by an
online system. This data is valuable to send
targeted advertisements to your customers.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>


       
      </div>
        <div class="container my-4">
          <div class="row">
            <div class="col-md-6 d-flex mx-auto align-items-center">
              <div class="m-q-a-768">
                <h1
                  class="
                    text-white
                    display-4
                    pb-2
                    pl-5
                    mquery-h
                    m-q-a-768-h m-q-850
                  "
                  style=""
                >
                  It’s All About the Success of Your Business.
                </h1>

                <p
                  class="mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p"
                  style="color: #eee"
                >
                  The straightforward and timely way to grow your business in
                  the modern world is an online business. Contact us to grow
                  your business now.
                </p>
                <!-- <router-link
                :to="{ name: 'regshop', params: { plan: 'Premium' } }"
                ><el-button
                  class="text-white ml-5 mb-3"
                  type="primary"
                  style="text-decoration: none"
                  ><h5>Create Store</h5></el-button
                ></router-link
              > -->
                <a href="tel:0719500600">
                  <el-button
                    class="text-white ml-5 mx-auto mb-3"
                    type="success"
                    style="
                      text-decoration: none;
                      display: block;
                      margin: 0 auto;
                    "
                    ><h5>0719 500 600</h5></el-button
                  >
                </a>
                <p
                  class="mb-2 h4 pb-2 mquery-p pl-5 m-q-a-768-p"
                  style="color: #eee"
                >
                  Need your own domain name? We can provide that too, Just call
                  us now.
                </p>
                <!-- <button v-scroll-to="{
                            el: '#blog', duration: 900,
                                easing: 'linear',
                            force: true,}" class='button pri py-3 text-white ml-5' style="text-decoration:none"><h5> VIEW PACKAGES</h5></button> -->

                <a href="tel:0719500600">
                  <el-button
                    class="text-white ml-5 mx-auto"
                    type="success"
                    style="
                      text-decoration: none;
                      display: block;
                      margin: 0 auto;
                    "
                    ><h5>0719 500 600</h5></el-button
                  >
                </a>
              </div>
            </div>
           
          </div>
        </div>
      </section>


    <div >
      <footer
        class="footer section section-sm footer-search"
        style="padding-bottom: 0px"
      >
        <!-- Container Start -->
        <div class="container">
          <div class="row justify-content-around">
            <!-- <div class="col-lg-3 col-md-7 offset-md-1 offset-lg-0">
        
        <div class="block about">
         
          <img src="images/logo-footer.png" alt="">
          
          <p class="alt-color text-secondary">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
        </div>
         <ul class="social-media-icons mb-3">
              <li><a class="fa fa-facebook" href=""></a></li>
              <li><a class="fa fa-twitter" href=""></a></li>
              <li><a class="fa fa-pinterest-p" href=""></a></li>
              <li><a class="fa fa-vimeo" href=""></a></li>
            </ul>
      </div> -->
            <!-- Link list -->
            <div class="col-sm-6 col-lg-3">
              <div class="block block-link">
                <h4>Site Pages</h4>
                <ul>
                  <li class="px-0">
                    <router-link :to="{ name: 'home' }">Home</router-link>
                  </li>
                  <!-- <li>
                    <router-link
                      :to="{ name: 'regshop', params: { plan: 'Premium' } }"
                      >Create Store</router-link
                    >
                  </li> -->
                  <li>
                    <router-link :to="{ name: 'about' }">About Us</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'termsofuse' }"
                      >Terms of Use</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'privacypolicy' }"
                      >Privacy Policy</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!-- Link list -->
            <div class="col-sm-6 col-lg-4" id="contactUs">
              <div class="block block-info">
                <h4>Contact Us</h4>
                <ul>
                  <li>
                    <a
                      ><i class="fa fa-phone mr-2" aria-hidden="true"></i>0719
                      500 600</a
                    >
                  </li>
                  <!-- <li>
                    <a
                      ><i class="fa fa-phone mr-2" aria-hidden="true"></i
                      >0113-601-444</a
                    >
                  </li> -->
                  <li>
                    <a
                      ><i class="fa fa-envelope mr-2" aria-hidden="true"></i
                      >info@eshops.lk</a
                    >
                  </li>
                </ul>
                <ul class="social-media-icons mb-2 d-inline">
                  <li style="">
                    <a
                      href="https://www.facebook.com/Eshopslk-2212428785713128/"
                      class="px-0 ml-0 mr-2"
                      ><i
                        class="fa fa-facebook-official f-sm-link"
                        style="
                          font-size: 34px;
                          color: #3b5998;
                          background-color: #fff;
                          width: 30px;
                          height: 30px;
                          border-radius: 4px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/eshops.lk/"
                      class="px-0 mx-2"
                      ><i
                        class="fa fa-instagram f-sm-link"
                        style="
                          font-size: 30px;
                          color: #fff;
                          background: #d6249f;
                          background: radial-gradient(
                            circle at 30% 107%,
                            #fdf497 0%,
                            #fdf497 5%,
                            #fd5949 45%,
                            #d6249f 60%,
                            #285aeb 90%
                          );
                          width: 32px;
                          height: 32px;
                          border-radius: 4px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UCJhY3IfJD3T2bA5PJ3SrMZw"
                      class="px-0 mx-2"
                      ><i
                        class="fa fa-youtube-square f-sm-link"
                        style="
                          font-size: 35px;
                          color: #ff0000;
                          background-color: #fff;
                          width: 30px;
                          height: 30px;
                          border-radius: 6px;
                          text-align: center;
                          vertical-align: middle;
                        "
                      ></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <!-- Promotion -->
            <div class="col-sm col-md-8 col-lg-5">
              <!-- App promotion -->
              <div class="block-2 app-promotion">
                <a>
                  <!-- Icon -->
                  <img
                    src="../../static/img/icons/footer-android-chrome-90x90.png"
                    alt="mobile-icon"
                  />
                </a>
                <p class="m-f-text">
                  Tap the Add to Home Screen Tab in Chrome Browser on Android or
                  Safari Browser on IOS to Get the Splendid
                  <span style="color: #fd6a02; font-size: 20px"
                    >Mobile App</span
                  >
                  Directly
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Container End -->
      </footer>
      <!-- Footer Bottom -->
      <footer class="footer-bottom">
        <!-- Container Start -->
        <div class="container">
          <div class="row">
            <div class="col-12 mx-auto mt-5">
              <div class="copyright text-center">
                <img src="../../static/img/eshops-logo.png" alt="eshops-logo" />
                <p class="m-f-text mt-2">
                  © {{ new Date().getFullYear() }} eshops.lk | All Rights
                  Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Container End -->
        <!-- To Top -->
      </footer>
      <!-- <button class="goTop" v-if="isVisible" @click="backToTop">
        <i class="fa fa-angle-up text-white" aria-hidden="true"></i>
    </button> -->
      <!-- <back-to-top bottom="90px" right="25px">
  <button type="button" class="btn btn-info btn-to-top"><i class="fa fa-chevron-up"></i></button>
</back-to-top> -->
    </div>
  </div>
  </div>
</template>

<script>
import db from "../config/FirebaseInit";
import firebase from "firebase/app";
import cities from "../data/cities";
import caticons from "../data/caticons";
import categories from "../data/maincategories";
export default {
  name: "startstore",
  data() {
    return {
      isVisible: false,
      user: false,
      visitor: false,
      admin: false,
      editor: false,
      deferredPrompt: false,
      starterplanadmin: false,
      pageadmin: false,
      searchForm: {
        category: undefined,
        location: undefined,
        shopname: "",
      },
      modalShow: false,
      labelPosition: "left",
      cities: [],
      categories: [],
      city: [],
      cat: [],
      loading: false,
      fetched: false,
      topshops: [],
      shopcats: [
        "Supermarket",
        "Clothing",
        "Shoes & Footwear",
        "Mobiles & Tablets",
      ],
    };
  },
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.push("/");
        });
    },

    showme() {
      if (
        this.searchForm.category == undefined ||
        this.searchForm.location == undefined
      ) {
        this.modalShow = true;
      } else {
        this.$router.push({
          name: "search",
          query: {
            cat: this.searchForm.category,
            loc: this.searchForm.location,
          },
        });
      }
    },
    showDialog(shop) {
      this.$router.push({
        name: "storehome",
        params: { storename: shop.owner },
      });
    },
    selectCat(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.category = value[0];
        //console.log('this.searchForm.category',this.searchForm.category)
      } else if (value.length == 2) {
        this.searchForm.category = value[1];
        //console.log('this.searchForm.category',this.searchForm.category)
      }
    },
    handleChange(value) {
      //console.log(value)
      if (value.length == 1) {
        this.searchForm.location = value[0];
      } else if (value.length == 2) {
        this.searchForm.location = value[1];
      }
      //console.log('this.searchForm.location',this.searchForm.location)
    },

    scrollWin() {
      window.scrollBy(0, 800);
    },
    promptInstall() {
      // Show the prompt:
      this.deferredPrompt.prompt();
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Wait for the user to respond to the prompt:
      //console.log("choiceResult.outcome",choiceResult.outcome)
      this.deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          alert("eSHOPS App is being Installed.");
        } else {
          //console.log("User dismissed the install prompt");
        }

        this.deferredPrompt = null;
      });
    },
  },
  created() {
    window.addEventListener("beforeinstallprompt", (e) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      //alert("deferredPrompt",this.deferredPrompt)
      this.deferredPrompt = e;
      //console.log("deferredPrompt e",this.deferredPrompt)
      // Update UI notify the user they can install the PWA
      //showInstallPromotion();
    });
    
    if (firebase.auth().currentUser) {
      if (firebase.auth().currentUser.displayName == null) {
        this.user = true;
      } else if (
        firebase.auth().currentUser.displayName == "shop owner" ||
        firebase.auth().currentUser.displayName == "starterplan shop owner"
      ) {
        this.admin = true;
      } else if (firebase.auth().currentUser.displayName == "page owner") {
        this.pageadmin = true;
      } else if (
        firebase.auth().currentUser.displayName == "editor" ||
        firebase.auth().currentUser.displayName == "super admin"
      ) {
        this.editor = true;
      }
    } else {
      this.visitor = true;
    }
    this.cities = cities;
    this.categories = categories;
    this.shopcats = caticons;
    this.$nextTick(function () {
      // this.initToTopButton();
    });
  },
};
</script>

<style scoped>
/* @import url('~@/assets/main/css/startstore.css'); */
@import url("~@/assets/main/css/styles.css");
@import url("~@/assets/main/css/nav.css");
@import url("~@/assets/main/css/button.css");
@import url("~@/assets/main/css/animate.min.css");
.m-nav {
  display: none;
}
.bg-dark {
  color: #180000 !important;
  background-color: #18000000 !important;
}
.shader {
  height: 260vh;
  margin: 0;
  padding: 0;
}
.section-why {
}
.goTop {
  cursor: pointer;
  border-radius: 5px;
  background-color: rgb(1, 14, 27);
  background-color: rgba(1, 14, 27, 0.7);
  position: fixed;
  width: 45px;
  height: 45px;
  display: block;
  right: 15px;
  bottom: 15px;
  border: none;
  opacity: 0;
  z-index: -1;
}
.isVisible {
  opacity: 0.8;
  z-index: 4;
  transition: all 0.4s ease-in;
}
.footer-search {
  margin-top: 0px;
}
.mquery-img {
  width: 720px;
  height: 660px;
}
.app-img {
  margin: 0px !important;
  width: 100%;
  height: 600px;
}
.txt-b {
  color: #424242;
}
.txt-g {
  color: #757575;
}
.s-s-h {
  height: 700px;
}
@media (max-width: 850px) {
  .m-q-850 {
    padding-top: 50px;
  }
}
@media (width: 768px) {
  .m-q-a-768 {
    margin-bottom: 20px;
  }
  .m-q-a-i-768 {
    margin-top: 38px !important;
  }
  .m-q-a-i-768-2 {
    margin: 20px 0px !important;
  }
  .m-q-a-i-768-3 {
    margin-top: 35px !important;
  }
  .m-q-a-768-h {
    font-size: 2.5rem !important;
  }
  .m-q-a-768-p {
    font-size: 1.2rem !important;
  }
}
@media (max-width: 767px) {
  .s-s-h {
    height: auto;
  }
  .mquery-p {
    color: #585858;
    font-weight: 340;
    line-height: 1.3;
    font-size: 18px;
  }
  .mquery-h {
    font-size: 30px;
  }
  .mquery-a {
    font-size: 14px;
  }
  .mquery-img {
    width: 180px;
  }
  .mquery-div {
    padding-top: 40px;
  }
  .section-why {
  }
  .d-nav {
    display: none;
  }
  .m-nav {
    display: block;
  }
  .bg-dark {
    color: #180000 !important;
    background-color: #0f010882 !important;
  }
  .navbar-brand {
    display: inline-block;
    padding-top: 0rem;
    padding-bottom: 0rem;
    margin-right: 1rem;
    line-height: inherit;
    white-space: nowrap;
  }
  .navbar-toggler {
    padding: 0rem;

    line-height: 1;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 0rem;
  }
}
@media (max-width: 575px) {
  .m-link {
    font-size: 14px;
  }
  .m-f-text {
    font-size: 12px;
  }
  .footer .block ul li a {
    font-size: 12px;
  }
  .m-h2-txt {
    font-size: 25px;
    margin-left: 10px;
  }
  .free-txt {
    font-size: 16px;
  }
  .free-a {
    width: 80% !important;
  }
}
@media (max-width: 1024px) {
  .infobox {
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    -webkit-animation: Grad;
    -moz-animation: Grad;
    animation: Grad;
  }
}
.infobox {
  /* background-color: #f9f9f9; */
  background: linear-gradient(
    to bottom right,
    #ee7752,
    #e73c7e,
    #23a6d5,
    #23d5ab 100%
  );
  /* background-size: 400% 400%; */
  /* -webkit-animation: Gradient 15s ease infinite;
	-moz-animation: Gradient 15s ease infinite;
	animation: Gradient 15s ease infinite; */
}
@-webkit-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@-moz-keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.cont {
  position: relative;
  top: 0;
  left: 0;
}
.displayh-4 {
  margin-top: 100px;
  font-weight: 800;
  /* font-family: Poppins-SemiBold; */
}
.m-link:hover {
  text-decoration: underline;
}
@media (max-width: 991px) {
  .displayh-4 {
    margin-top: 180px;
  }
}
@media (max-width: 767px) {
  .displayh-4 {
    font-size: 35px;
    margin-top: 200px;
    margin-bottom: 24px !important;
  }
  h3 {
    font-size: 25px;
  }
  .form-item {
    width: 200px;
  }
  /* .el-form{
    width: 200px;
  } */
  #section-home {
    background-position: right;
    background-size: cover;
  }
}
@media (max-width: 665px) {
  .el-form {
    width: 200px;
  }
  .mp {
    margin-top: 15px;
  }
}
@media (max-width: 575px) {
  nav {
    /* margin-bottom: 40px; */
  }
  .displayh-4 {
    font-size: 25px;
    margin-top: 240px;
    padding-top: 0;
  }
  h3 {
    font-size: 18px;
  }
  .m-link {
    font-size: 14px;
  }
}
@media (max-width: 340px) {
  .button-m-320 {
    min-width: 70px !important;
    text-align: center;
    padding: 9px 8px 8px !important;
    font-size: 14px !important;
  }
  .m-link {
    font-size: 14px;
  }
}
@media (max-height: 599px) {
  .displayh-4 {
    margin-top: 100px;
    font-size: 23px;
    margin-bottom: 24px !important;
  }
}

/* timeline css */
.benefits-list {
  list-style: circle !important;
  margin-left: 20px;
  font-size: 16px;
  color: #e36116;
}
.benefits-list li {
  list-style-type: circle;
}
.timeline {
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  position: relative;
  background-color: #f5f5f5;
}
.timeline__event {
  margin-bottom: 20px;
  position: relative;
  display: flex;
  margin: 20px 0;
  border-radius: 6px;
  align-self: center;
  width: 80vw;
}
.timeline__event:nth-child(2n + 1) {
  flex-direction: row-reverse;
}
.timeline__event:nth-child(2n + 1) .timeline__event__date {
  border-radius: 0 6px 6px 0;
}
.timeline__event:nth-child(2n + 1) .timeline__event__content {
  border-radius: 6px 0 0 6px;
}
.timeline__event:nth-child(2n + 1) .timeline__event__icon:before {
  content: "";
  width: 2px;
  height: 150%;
  background: #f6a4ec;
  position: absolute;
  top: 0%;
  left: -450%;
  right: auto;
  z-index: -1;
  transform: translateX(-50%);
  animation: fillTop 2s forwards 4s ease-in-out;
}
.timeline__event:nth-child(2n + 1) .timeline__event__icon:after {
  content: "";
  width: 100%;
  height: 2px;
  background: #f6a4ec;
  position: absolute;
  right: 0;
  z-index: -1;
  top: 50%;
  left: auto;
  transform: translateY(-50%);
  animation: fillLeft 2s forwards 4s ease-in-out;
}
.timeline__event__title {
  font-size: 1.2rem;
  line-height: 1.4;
  text-transform: uppercase;
  font-weight: 600;
  color: #9251ac;
  letter-spacing: 1.5px;
}
.timeline__event__content {
  padding: 20px;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
    0 18px 36px -18px rgba(0, 0, 0, 0.3), 0 -12px 36px -8px rgba(0, 0, 0, 0.025);
  background: #fff;
  width: calc(40vw - 84px);
  border-radius: 0 6px 6px 0;
}
.timeline__event__date {
  color: #f6a4ec;
  font-size: 1.5rem;
  font-weight: 600;
  background: #9251ac;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  padding: 0 20px;
  border-radius: 6px 0 0 6px;
}
.timeline__event__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9251ac;
  padding: 20px;
  align-self: center;
  margin: 0 20px;
  background: #f6a4ec;
  border-radius: 100%;
  width: 40px;
  box-shadow: 0 30px 60px -12px rgba(50, 50, 93, 0.25),
    0 18px 36px -18px rgba(0, 0, 0, 0.3), 0 -12px 36px -8px rgba(0, 0, 0, 0.025);
  padding: 40px;
  height: 40px;
  position: relative;
}
.timeline__event__icon i {
  font-size: 32px;
}
.timeline__event__icon:before {
  content: "";
  width: 2px;
  height: 150%;
  background: #f6a4ec;
  position: absolute;
  top: 0%;
  z-index: -1;
  left: 500%;
  transform: translateX(-50%);
  animation: fillTop 2s forwards 4s ease-in-out;
}
.timeline__event__icon:after {
  content: "";
  width: 100%;
  height: 2px;
  background: #f6a4ec;
  position: absolute;
  left: 0%;
  z-index: -1;
  top: 50%;
  transform: translateY(-50%);
  animation: fillLeftOdd 2s forwards 4s ease-in-out;
}
.timeline__event__description {
  flex-basis: 60%;
}
.timeline__event--type2:after {
  background: #555ac0;
}
.timeline__event--type2 .timeline__event__date {
  color: #87bbfe;
  background: #555ac0;
}
.timeline__event--type2:nth-child(2n + 1) .timeline__event__icon:before,
.timeline__event--type2:nth-child(2n + 1) .timeline__event__icon:after {
  background: #87bbfe;
}
.timeline__event--type2 .timeline__event__icon {
  background: #87bbfe;
  color: #555ac0;
}
.timeline__event--type2 .timeline__event__icon:before,
.timeline__event--type2 .timeline__event__icon:after {
  background: #87bbfe;
}
.timeline__event--type2 .timeline__event__title {
  color: #555ac0;
}
.timeline__event--type3:after {
  background: #24b47e;
}
.timeline__event--type3 .timeline__event__date {
  color: #aff1b6;
  background-color: #24b47e;
}
.timeline__event--type3:nth-child(2n + 1) .timeline__event__icon:before,
.timeline__event--type3:nth-child(2n + 1) .timeline__event__icon:after {
  background: #aff1b6;
}
.timeline__event--type3 .timeline__event__icon {
  background: #aff1b6;
  color: #24b47e;
}
.timeline__event--type3 .timeline__event__icon:before,
.timeline__event--type3 .timeline__event__icon:after {
  background: #aff1b6;
}
.timeline__event--type3 .timeline__event__title {
  color: #24b47e;
}
.timeline__event:last-child .timeline__event__icon:before {
  content: none;
}
@media (max-width: 786px) {
  .timeline__event {
    flex-direction: column;
    align-self: center;
  }
  .timeline__event__content {
    width: 100%;
  }
  .timeline__event__icon {
    border-radius: 6px 6px 0 0;
    width: 100%;
    margin: 0;
    box-shadow: none;
  }
  .timeline__event__icon:before,
  .timeline__event__icon:after {
    display: none;
  }
  .timeline__event__date {
    border-radius: 0;
    padding: 20px;
  }
  .timeline__event:nth-child(2n + 1) {
    flex-direction: column;
    align-self: center;
  }
  .timeline__event:nth-child(2n + 1) .timeline__event__date {
    border-radius: 0;
    padding: 20px;
  }
  .timeline__event:nth-child(2n + 1) .timeline__event__icon {
    border-radius: 6px 6px 0 0;
    margin: 0;
  }
}
@keyframes fillLeft {
  100% {
    right: 100%;
  }
}
@keyframes fillTop {
  100% {
    top: 100%;
  }
}
@keyframes fillLeftOdd {
  100% {
    left: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Restaurants.vue